import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { invoicePaymentStatusParser } from '#validation';
export const InvoiceResponseSchema = z.object({
    id: z.string(),
    date: z.number(),
    lineDescriptions: z.array(z.string()),
    amountDue: z.number(),
    currency: z.string(),
    periodStart: z.number(),
    periodEnd: z.number(),
    paymentStatus: invoicePaymentStatusParser,
    downloadInvoicePdfUrl: z.url().nullish(),
    payNowInvoiceUrl: z.url().nullish(),
});
export class InvoiceResponseDto extends createZodDto(InvoiceResponseSchema) {
}
